<template>
    <div>
        <input
            type="text"
            v-model="search"
            placeholder="Search..."
            class="input"
            v-show="hasSearch"
        >
        <nav class="letters-pagination" v-if="pagination">
            <span
                v-for="letter in letters"
                :key="letter"
                v-text="letter"
                @click="applyLetter(letter)"
                :class="letterCssClass(letter)"
            ></span>
        </nav>
        <div class="divider"></div>
        <div class="grid-x grid-margin-x grid-margin-y small-up-1 medium-up-2 grid grid-image-caption" v-if="filteredItems.length > 0">
            <div
                class="cell border hover:border-color:primary"
                v-for="(item, index) in filteredItems"
                :key="index"
            >
                <slot :item="item"></slot>
            </div>
        </div>
        <p v-else>There are no records matching "<strong v-text="search"></strong>".</p>
    </div>
</template>
<script>
    import Helper from '../../core/Helper';
    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                required: false,
            },
            items: {
                type: [Object, Array],
                default: () => [],
            },
            hasSearch: {
                type: Boolean,
                default: true,
            },
            pagination: {
                type: Boolean,
                default: false
            },
            sortBy: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                search: null,
                letter: null,
                sort: this.sortBy ? this.sortBy : this.name,
            }
        },
        computed: {
            filteredItems() {
                let records = this.items,
                    keyword = (this.search ? this.search.toLowerCase() : null);

                if (keyword) {
                    records = records.filter(item => {
                        return (
                            item[this.name].toLowerCase().includes(keyword) ||
                            (
                                item[this.description] &&
                                item[this.description].toLowerCase().includes(keyword)
                            )
                        );
                    });
                } else if (this.letter !== null) {
                    records = records.filter(item => this.firstLetter(item) === this.letter);
                }

                return records.sort((a, b) => {
                    a = a[this.sort].toString().replace(/"/g,'');
                    b = b[this.sort].toString().replace(/"/g,'');
                    if (a < b) {
                        return -1;
                    }
                    if (a > b) {
                        return 1;
                    }
                    return 0;
                });
            },
            letters() {
                return Helper.sort([...new Set(this.items.map(item => this.firstLetter(item)))]);
            }
        },
        mounted() {
            this.initialize();
        },
        methods: {
            initialize() {
                if (!this.pagination || this.sort === 'sort') {
                    return;
                }
                let items = this.filteredItems;
                if (items.length > 0) {
                    this.applyLetter(this.firstLetter(items[0]))
                }
            },
            firstLetter(item) {
                return item[this.name].replace(/[^a-z0-9+]+/gi, '').charAt(0).toUpperCase();
            },
            applyLetter(letter) {
                if (this.isLetterSelected(letter)) {
                    this.letter = null;
                } else {
                    this.letter = letter;
                    this.search = null;
                }
            },
            isLetterSelected(letter) {
                if (this.search) {
                    return false;
                }
                return this.letter === letter;
            },
            letterCssClass(letter) {
                return {
                    active: this.isLetterSelected(letter)
                }
            }
        }
    }
</script>
